import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

interface PaymentSuccessDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function PaymentSuccessDialog({ open, onClose }: PaymentSuccessDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundImage: 'none',
          overflow: 'hidden',
        },
      }}
    >
      <DialogContent sx={{ px: { xs: 3, sm: 4 }, pt: 4, pb: 2, textAlign: 'center' }}>
        <Box
          sx={{
            width: 72,
            height: 72,
            mx: 'auto',
            mb: 2.5,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            bgcolor: 'rgba(34, 197, 94, 0.12)',
          }}
        >
          <CheckCircleRoundedIcon sx={{ color: '#22c55e', fontSize: 48 }} />
        </Box>

        <Typography variant="h5" fontWeight={800} sx={{ mb: 1 }}>
          Payment successful
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.65 }}>
          Your Super Connector one-time setup fee has been received successfully.
        </Typography>
        <Box
          sx={{
            mt: 2.5,
            px: 2,
            py: 1.5,
            borderRadius: 2,
            bgcolor: 'action.hover',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Your payment status is now updated to <strong>Paid</strong>. Your receipt will be available once processing is complete.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: { xs: 3, sm: 4 }, pb: 3.5, pt: 1.5 }}>
        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={onClose}
          sx={{
            bgcolor: '#ed8936',
            color: '#111827',
            textTransform: 'none',
            fontWeight: 800,
            '&:hover': { bgcolor: '#f59e52' },
          }}
        >
          Continue to Super Connector
        </Button>
      </DialogActions>
    </Dialog>
  );
}
